import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import EnquiryList from './components/EnquiryList';
import EnquiryDetails from './components/EnquiryDetails';
import request from '../../service';
import Exported from '../../service/endpoints';
import { useDispatch } from 'react-redux';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import ModalDropdown from '../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, useForm } from 'react-hook-form';
import Button from '../../component/Button';
import InputBox from '../../component/InputBox';

const ProductEnquiry = () => {
    const NAME = 'Name'
    const STATUS = 'Status'
    const dropdownList = [
        { label: NAME, value: [NAME] },
        { label: STATUS, value: [STATUS] },
    ]
    const [page, setPage] = useState(1);
    const [productTableList, setProductTableList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [viewProduct, setViewProduct] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [sortSelected, setSortSelected] = useState(null)
    const [isDropdown, setIsDropdown] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [prodId, setProdId] = useState()
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        resetField,
    } = formMethods;

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?id=')
            const params = pathName[pathName?.length - 1]
            if (params) {
                setViewProduct(true)
            } else {
                setViewProduct(false)
            }
        }
    }, [location])

    const getProductList = async (loading) => {
        setisLoading(loading)

        let url = `${Exported.Endpoints.productEnquiryList}`
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            console.log(res)
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta,
                }
                setProductTableList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectTo = () => {
        navigate(`?type=create`)
    }
    const handleStatus = (id) => {
        setProdId(id)
        setIsOpen(true);
    }

    const closePopUp = () => {
        setIsOpen(false)
    }

    const onSubmit = async (data) => {
        dispatch(saveLoadingState(true))
        await request({
            url: `${Exported.Endpoints.resolveProduct}?enquiry_id=${prodId}`,
            method: Exported.APIMethods.PUT,
            data: {
                enquiry_id: prodId,
                admin_comment: data?.reason,
                is_resolved: true,
                status: 3
            }
        }).then(async (res) => {
            if (res?.data?.status) {
                await getProductList(true)
                setIsOpen(false);
                resetField('reason')
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }
    


    return (
        <>
            {viewProduct ?
                <EnquiryDetails /> :
                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>Product Enquiry</div>
                        <div className='flex items-center'>
                            <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by name, enquiry id...'} />
                        </div>
                    </div>
                    <div>
                        <EnquiryList
                            searchInput={searchInput}
                            handleStatus={handleStatus}
                            page={page}
                            setPage={setPage}
                            productTableList={productTableList}
                            setProductTableList={setProductTableList}
                            isLoading={isLoading}
                            setisLoading={setisLoading}
                            sortConfig={sortConfig}
                            setSortConfig={setSortConfig}
                            getProductList={getProductList}
                        />
                    </div>
                </div>
            }
            {isOpen ? <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.reasonModalWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Add Internal Comment</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.reasonFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formGroup}`}>

                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Comment"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"reason"}
                                        type={"textarea"}
                                        {...register("reason", {
                                            required: true,
                                        })}
                                        error={errors.reason}
                                        messages={{
                                            required: "Reason is required",
                                        }}
                                    />
                                </div>
                                <div className='flex justify-end'>
                                    <Button text={"Submit"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown> : null}

        </>
    )
}

export default ProductEnquiry